import { setProductValue } from '../../../actions/productCreateAction'
import { constants as cons } from '../../../Constants/constants'
import store from '../../../store'

const couponImagePaths = ['draft.product.imageMedia.cashCouponDetailImage', 'draft.product.imageMedia.cashCouponDetailPurchasedImage'];

// Declarative mapping from a changed field -> dependent fields to clear
const CLEAR_DEPENDENCIES = {
  brandCode: couponImagePaths,
  type: couponImagePaths,
  originalPrice: couponImagePaths,
  // sellingPrice: couponImagePaths,
  // redemptionMinCharge: couponImagePaths,
  // cashCouponLeftImage: couponImagePaths,
  // cashCouponBrandImage: couponImagePaths,
}

// Keep the original signature for compatibility: (dispatch, savedProductOrName, changedFieldName?)
export async function maybeClearDependentFields(dispatch, savedProductOrName, changedFieldName) {
  try {
    // determine which argument is the field name
    let fieldKey = changedFieldName
    if (!fieldKey) {
      // if caller passed a string as the second arg, use that
      if (typeof savedProductOrName === 'string') fieldKey = savedProductOrName
    }

    if (!fieldKey) return

    // normalize common cases: accept LEFT_IMAGE constant as equivalent to 'leftImage'
    const normalizedKey = (() => {
      if (fieldKey === cons.ACTION_KEY.PRODUCT.LEFT_IMAGE || fieldKey === 'LEFT_IMAGE') return 'cashCouponLeftImage'
      return fieldKey
    })()

    const deps = CLEAR_DEPENDENCIES[normalizedKey] || CLEAR_DEPENDENCIES[fieldKey]
    if (!deps || deps.length === 0) return

    // Always use latest product state from the store to avoid overwriting recent changes
    // 1. Fetch latest product state from the store
    const latestProduct = store.getState().product.ui.product
    
    // 2. Deep clone it so we can safely accumulate multiple updates in local memory
    const updatedProduct = _.cloneDeep(latestProduct)

    // 3. Loop through dependencies and update our local clone instead of dispatching
    await deps.forEach((fieldPath) => {
      _.set(updatedProduct, fieldPath, null)
    })

    // 4. Dispatch exactly ONCE using the fully updated product clone.
    // We pass the last field path from the array so your action creator handles it correctly.
    const lastFieldPath = deps[deps.length - 1]
    dispatch(
      setProductValue(cons.ACTION_KEY.PRODUCT.PRODUCT, updatedProduct, lastFieldPath, null)
    )

    // deps.forEach((fieldPath) => {
    //   // Clear only the generated detail images for cash coupon items
    //   dispatch(
    //     setProductValue(cons.ACTION_KEY.PRODUCT.PRODUCT, latestProduct, fieldPath, null)
    //   )
    // })
  } catch (e) {
    // swallow — helper should not break UI flow
    // eslint-disable-next-line no-console
    console.error('maybeClearDependentFields error', e)
  }
}

export default maybeClearDependentFields
